import React from 'react';
import AvlagaUglugTovchooTC from './avlagaUglug';

const PageList = () => <AvlagaUglugTovchooTC />;

export default PageList;
